import { Routes } from '@angular/router';
import { LogInComponent } from './pages/log-in/log-in.component';
import { MsalGuard } from '@azure/msal-angular';
import { UserRolesGuard } from './core/guards/user-roles.guard';
import { SystemAdminGuard } from './core/guards/system-admin.guard';
import { SectionGroupAdminGuard } from './core/guards/section-group-admin.guard';

// import { HomeLayoutComponent } from './features/home/home-layout/home-layout.component';
import { HomeNavComponent } from './features/home/home-nav/home-nav.component';
import { JoinSectionComponent as JoinSectionComponent } from './pages/join-section/join-section.component';
import { JoinSectionConfirmedComponent } from './pages/join-section-confirmed/join-section-confirmed.component';
import { JoinSectionGuard } from './core/guards/join-section.guard';
import { MeasuredDataDetailsComponent } from './features/home/measured-data-details/measured-data-details.component';
import { UserSummaryComponent } from './features/home/user-summary/user-summary.component';
import { UserRecordListComponent } from './features/home/user-record-list/user-record-list.component';
import { UserListComponent } from './features/admin-section/user-list/user-list.component';
import { UserDetailsComponent } from './features/admin-section/user-details/user-details.component';
import { ContributorPickerComponent } from './features/admin-section/contributor-picker/contributor-picker.component';
import { CreateUserComponent } from './features/admin-section/user-create/user-create.component';
import { AccountInfoComponent } from './account-info/account-info.component';
import { HomeUserListComponent } from './features/home/home-user-list/home-user-list.component';
import { HomeMentionListComponent } from './features/home/home-mention-list/home-mention-list.component';
import { GostSummaryComponent } from './features/home/gost-summary/gost-summary.component';
import { GostWorkspaceComponent } from './features/home/gost-workspace/gost-workspace.component';
import { GostMatrixComponent } from './features/home/gost-matrix/gost-matrix.component';
import { TomassSummaryComponent } from './features/home/tomass-summary/tomass-summary.component';
import { NotFoundComponent } from './pages/errors/not-found/not-found.component';
import { UnauthorizedComponent } from './pages/errors/unauthorized/unauthorized.component';
import { SystemErrorComponent } from './pages/errors/system-error/system-error.component';
import { ContractStatusGuard } from './core/guards/contract-status.guard';
import { featureGuard } from './core/guards/feature.guard';
import { ExpertDialogComponent } from './features/home/expert-dialog/expert-dialog.component';
import { UserMediaComponent } from './features/home/user-media/user-media.component';
import { MediaDetailComponent } from './features/home/user-media/media-detail/media-detail.component';
import { ManualComponent } from './features/home/manual/manual.component';
import { SupportComponent } from './features/home/support/support.component';
import { TermOfUseComponent } from './pages/static/term-of-use/term-of-use.component';
import { PrivacyPolicyComponent } from './pages/static/privacy-policy/privacy-policy.component';
import { LicenseComponent } from './pages/static/license/license.component';
import { BuildInfoComponent } from './pages/static/build_info/build_info.component';
import { environment } from '../environments/environment';

import { AdminNavComponent } from './features/admin-section/admin-nav/admin-nav.component';
import { AdminHomeComponent } from './features/admin-section/home/home.component';
import { StaffListComponent } from './features/admin-section/staff-list/staff-list.component';
import { StaffDetailsComponent } from './features/admin-section/staff-details/staff-details.component';
import { StaffInvitationComponent } from './features/admin-section/staff-invitation/staff-invitation.component';
import { CreateRecordsDownloadRequest } from './features/admin-section/create-records-download-request/create-records-download-request.component';
import { RecordsDownloadRequestComponent } from './features/admin-section/records-download-request-list/records-download-request-list.component';

import { SectionGroupAdminNavComponent } from './features/admin-section-group/section-group-admin-nav/section-group-admin-nav.component';
import { SectionGroupAdminHomeComponent } from './features/admin-section-group/home/section-group-home.component';
import { SectionsListComponent } from './features/admin-section-group/sections-list/sections-list.component';
import { SectionDetailsComponent } from './features/admin-section-group/section-details/section-details.component';

import { SystemAdminNavComponent } from './features/admin-system/system-admin-nav/system-admin-nav.component';
import { SystemAdminHomeComponent } from './features/admin-system/home/system-admin-home.component';
import { SectionGroupListComponent } from './features/admin-system/section-group-list/section-group-list.component';
import { SectionGroupDetailsComponent } from './features/admin-system/section-group-details/section-group-details.component';
import { UserContextResolver } from './core/resolvers/user-context.resolver';
import { UserDetailLayoutComponent } from './features/home/user-detail-layout/user-detail-layout.component';
import { SectionGroupAdminListComponent } from './features/admin-section-group/section-group-admin-list/section-group-admin-list.component';
import { SystemAdminListComponent } from './features/admin-system/system-admin-list/system-admin-list.component';
import { UserDataTemplateListComponent } from './features/admin-system/user-data-template-list/user-data-template-list.component';
import { MonthlySummariesListComponent } from './features/admin-system/monthly-summaries-list/monthly-summaries-list.component';
import { CreateSectionGroupAndSection } from './features/admin-system/create-section-group-and-section/create-section-group-and-section.component';
import { DistributorListComponent } from './features/admin-system/distributor-list/distributor-list.component';

export const appRoutes: Routes = [
  {
    path: '',
    component: LogInComponent
  },
  // ------------------ MSAL ROUTES ---------------------//
  // {
  //   // Dedicated route for redirects
  //   path: 'auth',
  //   component: MsalRedirectComponent
  // },
  {
    // Needed for hash routing
    path: 'error',
    component: LogInComponent
  },
  {
    // Needed for hash routing
    path: 'state',
    component: LogInComponent
  },
  {
    // Needed for hash routing
    path: 'code',
    component: LogInComponent
  },
  {
    // Needed for hash routing
    path: '',
    component: LogInComponent
  },
  // ------------------ OUR ROUTES ---------------------//
  {
    path: 'login',
    component: LogInComponent
  },
  {
    path: 'join-section',
    component: JoinSectionComponent,
    canActivate: [JoinSectionGuard]
  },
  {
    path: 'join-section-confirmed',
    component: JoinSectionConfirmedComponent,
    // canActivate: [MsalGuard]
  },
  {
    path: 'tou',
    component: TermOfUseComponent,
    // canActivate: [MsalGuard]
  },
  {
    path: 'privacy',
    component: PrivacyPolicyComponent,
    // canActivate: [MsalGuard]
  },
  {
    path: 'build-info',
    component: BuildInfoComponent,
    // canActivate: [MsalGuard]
  },
  // Dev-only: license page
  ...(environment.production ? [] : [
    { path: 'license', component: LicenseComponent },
  ]),
  // {
  //   path: 'section-list',
  //   component: SectionListComponent,
  //   canActivate: [MsalGuard]
  // },
  // {
  //   path: 'create-section',
  //   component: CreateSectionComponent,
  //   canActivate: [MsalGuard]
  // },
  // {
  //   path: 'update-section',
  //   component: UpdateSectionComponent,
  //   canActivate: [MsalGuard]
  // },
  // {
  //   path: 'update-user',
  //   component: UpdateUserComponent,
  //   canActivate: [MsalGuard]
  // },
  // {
  //   path: 'account-info',
  //   component: AccountInfoComponent,
  //   canActivate: [MsalGuard]
  // },
  // {
  //   path: 'channels',
  //   component: HomeLayoutComponent,
  //   canActivate: [MsalGuard],
  //   children: [
  //     { path: 'measured-data-list', component: MeasuredDataListComponent },
  //     { path: 'measured-data-details/:id', component: MeasuredDataDetailsComponent },
  //     { path: 'user-summary/:id', component: UserSummaryComponent },
  //     { path: '**', component: HomeSummaryComponent },
  //   ]
  // },
  {
    path: 'home/:sectionId',
    component: HomeNavComponent,
    canActivate: [MsalGuard, ContractStatusGuard],
    canActivateChild: [ContractStatusGuard],
    resolve: { userContext: UserContextResolver },
    children: [
      { path: '', redirectTo: 'users', pathMatch: 'full' },
      {
        path: 'users',
        component: HomeUserListComponent,
        resolve: { userContext: UserContextResolver },
      },
      {
        path: 'mentions',
        component: HomeMentionListComponent,
        canActivate: [featureGuard],
        data: { requiredFeature: 'Dialog', checkAllSectionGroups: true },
      },
      {
        path: 'tomass-summary',
        component: TomassSummaryComponent,
        canActivate: [featureGuard],
        data: { requiredFeature: 'TOMASS_SUM' },
      },
      {
        path: 'users/:userId',
        component: UserDetailLayoutComponent,
        resolve: { userContext: UserContextResolver },
        children: [
          { path: '', redirectTo: 'summaries', pathMatch: 'full' },
          {
            path: 'summaries',
            component: UserSummaryComponent,
            canActivate: [featureGuard],
            data: { requiredFeature: 'UserData' },
          },
          {
            path: 'records',
            component: UserRecordListComponent,
          },
          {
            path: 'records/:recordId',
            component: MeasuredDataDetailsComponent,
          },
          {
            path: 'dialogs',
            component: ExpertDialogComponent,
            canActivate: [featureGuard],
            data: { requiredFeature: 'Dialog' },
          },
          {
            path: 'medias',
            component: UserMediaComponent,
            canActivate: [featureGuard],
            data: { requiredFeature: 'Video' },
          },
          {
            path: 'medias/:mediaId',
            component: MediaDetailComponent,
            canActivate: [featureGuard],
            data: { requiredFeature: 'Video' },
          },
          {
            path: 'gost',
            component: GostWorkspaceComponent,
            canActivate: [featureGuard],
            data: { requiredFeature: 'GOST' },
            children: [
              { path: '', redirectTo: 'overview', pathMatch: 'full' },
              {
                path: 'overview',
                component: GostSummaryComponent,
              },
              {
                path: 'progress',
                component: GostMatrixComponent,
              },
              {
                path: 'records/:recordId',
                component: MeasuredDataDetailsComponent,
              },
              {
                path: 'manual',
                redirectTo: 'records/new_gost',
                pathMatch: 'full',
              },
            ],
          },
        ],
      },
      { path: 'manual', component: ManualComponent },
      { path: 'not-found', component: NotFoundComponent},
      { path: 'unauthorized', component: UnauthorizedComponent},
      { path: 'tou', component: TermOfUseComponent},
      { path: 'privacy',component: PrivacyPolicyComponent},
      { path: 'build-info', component: BuildInfoComponent },
      ...(environment.production ? [] : [{ path: 'license', component: LicenseComponent }]),
      { path: '**', redirectTo: '/en/home', pathMatch: 'full' },
    ]
  },
  { path: 'section-admin', redirectTo: '/not-found', pathMatch: 'full' },
  {
    path: 'section-admin',
    canActivate: [MsalGuard],
    children: [
      {
        path: ':sectionId',
        component: AdminNavComponent,
        canActivate: [UserRolesGuard, ContractStatusGuard],
        canActivateChild: [UserRolesGuard, ContractStatusGuard],
        children: [
          { path: '', redirectTo: 'home', pathMatch: 'full' },
          { path: 'manual', component: ManualComponent },
          { path: 'tou', component: TermOfUseComponent },
          { path: 'privacy', component: PrivacyPolicyComponent },
          { path: 'support', component: SupportComponent },
          { path: 'build-info', component: BuildInfoComponent },
          ...(environment.production ? [] : [{ path: 'license', component: LicenseComponent }]),
          { path: 'home', component: AdminHomeComponent },
          { path: 'staff-list', component: StaffListComponent },
          { path: 'contributor-list', component: StaffListComponent },
          { path: 'supervisor-list', component: StaffListComponent },
          { path: 'user-list', component: UserListComponent },
          { path: 'staff-invite', component: StaffInvitationComponent },
          { path: 'contributor-invite', component: StaffInvitationComponent },
          { path: 'supervisor-invite', component: StaffInvitationComponent },
          { path: 'create-user', component: CreateUserComponent },
          { path: 'staff-details/:id', component: StaffDetailsComponent },
          { path: 'user-details/:id', component: UserDetailsComponent },
          { path: 'records-download-requests', component: RecordsDownloadRequestComponent },
          { path: 'create-records-download-requests', component: CreateRecordsDownloadRequest },
          { path: 'monthly-summaries/:year/:month', component: MonthlySummariesListComponent},
          { path: 'not-found', component: NotFoundComponent},
          { path: 'unauthorized', component: UnauthorizedComponent},
          { path: '**', redirectTo: '/not-found', pathMatch: 'full' }
        ]
      },
    ]
  },
  {
    path: 'section-group-admin',
    component: SectionGroupAdminNavComponent,
    canActivate: [MsalGuard, SectionGroupAdminGuard],
    canActivateChild: [SectionGroupAdminGuard],
    children: [
      { path: 'support', component: SupportComponent },
      { path: 'manual', component: ManualComponent },
      { path: 'tou', component: TermOfUseComponent },
      { path: 'privacy', component: PrivacyPolicyComponent },
      { path: 'build-info', component: BuildInfoComponent },
      ...(environment.production ? [] : [{ path: 'license', component: LicenseComponent }]),
      { path: ':sectionGroupId',
        children: [
          { path: '', redirectTo: 'home', pathMatch: 'full' },
          { path: 'tou', component: TermOfUseComponent },
          { path: 'privacy', component: PrivacyPolicyComponent },
          { path: 'build-info', component: BuildInfoComponent },
          ...(environment.production ? [] : [{ path: 'license', component: LicenseComponent }]),
          { path: 'home', component: SectionGroupAdminHomeComponent },
          { path: 'sections', component: SectionsListComponent },
          // { path: 'new-section', component: SectionDetailsComponent },
          { path: 'admins', component: SectionGroupAdminListComponent},
          { path: 'monthly-summaries/:year/:month', component: MonthlySummariesListComponent},
          { path: 'not-found', component: NotFoundComponent},
          { path: 'unauthorized', component: UnauthorizedComponent},
          { path: '**', redirectTo: '/not-found', pathMatch: 'full' },
          // { path: '**', redirectTo: '/section-group-admin/home', pathMatch: 'full' },
        ]
      }
    ]
  },
  {
    path: 'system-admin',
    component: SystemAdminNavComponent,
    canActivate: [MsalGuard, SystemAdminGuard],
    canActivateChild: [SystemAdminGuard],
    children: [
          { path: '', redirectTo: 'home', pathMatch: 'full' },
          { path: 'tou', component: TermOfUseComponent },
          { path: 'privacy', component: PrivacyPolicyComponent },
          { path: 'build-info', component: BuildInfoComponent },
          ...(environment.production ? [] : [{ path: 'license', component: LicenseComponent }]),
          { path: 'home', component: SystemAdminHomeComponent },
          { path: 'section-groups', component: SectionGroupListComponent },
          { path: 'create-section-group-and-section', component: CreateSectionGroupAndSection },
          { path: 'section-groups/:sectionGroupId', component: SectionGroupDetailsComponent },
          { path: 'user-data-template', component: UserDataTemplateListComponent },
          // { path: 'new-section-group', component: StaffDetailsComponent },
          { path: 'admins', component: SystemAdminListComponent },
          { path: 'distributors', component: DistributorListComponent },
          { path: 'monthly-summaries/:year/:month', component: MonthlySummariesListComponent},
          { path: 'not-found', component: NotFoundComponent},
          { path: 'unauthorized', component: UnauthorizedComponent},
          // { path: '**', redirectTo: '/system-admin/section-groups', pathMatch: 'full' },
          { path: '**', redirectTo: '/not-found', pathMatch: 'full' },
    ]
  },
  {
    path: 'not-found',
    component: NotFoundComponent
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent
  },
  {
    path: 'system-error',
    component: SystemErrorComponent
  },
  // {
  //   path: 'channels/:name',
  //   component: ChannelComponent,
  //   canActivate: [MsalGuard]
  // }
  // Dev-only routes (excluded in production)
  ...(environment.production ? [] : [
    {
      path: 'dev/dialogs',
      loadComponent: () => import('./pages/dev/dialog-preview.component').then(m => m.DialogPreviewComponent),
    },
  ]),
  {
    path: '**',
    component: LogInComponent
  },
];
